import {
  CLICK_SCAN,
  UPDATE_PRODUCT_FAIL,
  UPDATE_PRODUCT,
  SEARCH_SCANPACK_ORDER,
  SEARCH_SCANPACK_ORDER_FAIL,
  DETECT_ORDERS_DISCREPANCIES,
  DASHBOARD_DATA,
  CHECK_IMPORT_ORDER_STATUS_SUCCESS,
  CHECK_IMPORT_ORDER_STATUS_FAIL,
  RESET_SCANPACK_ORDER,
  OFFLINE_DATA,
  SHOW_DUPLICATE_PICK_WARNING,
  HIDE_DUPLICATE_PICK_WARNING,
  SHOW_DUPLICATE_PICK_TOAST,
  HIDE_DUPLICATE_PICK_TOAST,
  ON_DEMAND_IMPORT_EVENT,
  CLEAR_ON_DEMAND_IMPORT_EVENT
} from '../constants';

const initialState = {
  offlineData : [],
  showDuplicatePickWarning: false,
  duplicatePickWarningData: null,
  showDuplicatePickToast: false,
  onDemandImport: null
};

const scanpackReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PRODUCT:
      return {...state, updatedProduct: action.payload};
    case SEARCH_SCANPACK_ORDER:
      return {...state, searchOrder: action.payload, time: new Date()};
    case RESET_SCANPACK_ORDER:
      return {...state, searchOrder: null, time: new Date()};
    case SEARCH_SCANPACK_ORDER_FAIL:
      return {...state, searchOrder: action.payload, time: new Date()};
    case UPDATE_PRODUCT_FAIL:
      return {...state, searchOrder: action.payload, time: new Date()};
    case DETECT_ORDERS_DISCREPANCIES:
      return {...state, orders_data: action.payload, time: new Date()};
    case DASHBOARD_DATA:
      return {...state, dashboardData: action.payload, time: new Date()};
    case CHECK_IMPORT_ORDER_STATUS_SUCCESS:
      return {...state, checkOrderStatus: action.payload, time: new Date()};
    case CHECK_IMPORT_ORDER_STATUS_FAIL:
      return {...state, checkOrderStatus: action.payload, time: new Date()};
      case OFFLINE_DATA:
        return {...state, offlineData: !action.payload?.length ? [] :  [...state.offlineData, ...action.payload], time: new Date()};
    case SHOW_DUPLICATE_PICK_WARNING:
      return {...state, showDuplicatePickWarning: true, duplicatePickWarningData: action.payload, time: new Date()};
    case HIDE_DUPLICATE_PICK_WARNING:
      return {...state, showDuplicatePickWarning: false, duplicatePickWarningData: null, time: new Date()};
    case SHOW_DUPLICATE_PICK_TOAST:
      return {...state, showDuplicatePickToast: true, time: new Date()};
    case HIDE_DUPLICATE_PICK_TOAST:
      return {...state, showDuplicatePickToast: false, time: new Date()};
    case ON_DEMAND_IMPORT_EVENT:
      return {...state, onDemandImport: action.payload, time: new Date()};
    case CLEAR_ON_DEMAND_IMPORT_EVENT:
      return {...state, onDemandImport: null, time: new Date()};
    default:
      return state;
  }
};

export default scanpackReducer;
